<template>
  <v-container>
    <div class="_fs-36 mt-md-4 mt-8">
      คู่มือการใช้งาน
    </div>
    <div class="mt-4 _fs-20">
      คู่มือแนะนำการใช้งาน ที่จะทำให้คุณใช้งานได้อย่างเต็มประสิทธิภาพ
    </div>

    <v-expansion-panels
      flat
      class="mt-8"
    >
      <v-expansion-panel
        style="border: 1px solid lightgray"
        class="rounded-xl"
      >
        <v-expansion-panel-header
          style="height: 90px"
        >
          <div class="_fs-24 font-weight-bold">
            ผู้ใช้ใหม่ (New User)
          </div>
          <template v-slot:actions>
            <v-icon
              x-large
              class="mr-4"
            >
              $expand
            </v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-divider />

          <div>
            <div class="_fs-20 font-weight-bold mt-8">
              1. ล็อคอินผ่าน LINE เพื่อเข้าสู่ระบบ
            </div>
            <img
              class=""
              src="/img/manual/new-user/new-user-step-1.jpg"
              alt="new-user-step-1"
              width="100%"
            />

            <div class="_fs-20 font-weight-bold mt-8">
              2. เลือก "ลูกค้าใหม่"
            </div>
            <img
              class="mt-8"
              src="/img/manual/new-user/new-user-step-2.jpg"
              alt="new-user-step-2"
              width="100%"
            />

            <div class="_fs-20 font-weight-bold mt-8">
              3. เลือกแพ็กเกจที่คุณต้องการ
            </div>
            <img
              class="mt-8"
              src="/img/manual/new-user/new-user-step-3.jpg"
              alt="new-user-step-3"
              width="100%"
            />

            <div class="_fs-20 font-weight-bold mt-8">
              4. เลือกบริการเสริม
            </div>
            <div class="_fs-20 mt-4 ml-8">
              &#8226; ข้อความเพิ่มเติม
              คุณสามารถกรอกข้อความเพิ่มเติมที่จะซื้อได้ตามต้องการ (ขั้นต่ำ 1,000 บาท)
            </div>
            <img
              class="mt-8"
              src="/img/manual/new-user/new-user-step-4-1.jpg"
              alt="new-user-step-4-1"
              width="100%"
            />

            <div class="_fs-20 mt-8 ml-8">
              &#8226; ซื้อพรีเมียม ไอดี (Premium ID)
              ไอดีที่บอกความเป็นแบรนด์ของคุณและระบุวันที่ต้องการใช้งาน
              โดย Premium ID มีอายุการใช้งาน 12 เดือน
            </div>
            <img
              class="mt-8"
              src="/img/manual/new-user/new-user-step-4-2.jpg"
              alt="new-user-step-4-2"
              width="100%"
            />

            <div class="_fs-20 font-weight-bold mt-8">
              5. คุณมี LINE Official Account หรือไม่?
            </div>
            <div class="_fs-20 mt-4 ml-8">
              &#8226; ย้ายบัญชีเข้า Sellsuki: มี LINE OA มาก่อน แต่ไม่เคยใช้บริการกับ Sellsuki
              โดยระบุ Display name และ Basic ID ของ LINE OA ที่ใช้ในปัจจุบัน
              และเลือกช่องทางที่เคยใช้บริการ
            </div>
            <img
              class="mt-8"
              src="/img/manual/new-user/new-user-step-5-1.jpg"
              alt="new-user-step-5-1"
              width="100%"
            />

            <div class="_fs-20 mt-8 ml-8">
              &#8226; เปิดบัญชีใหม่: กรอกแค่ Display name ที่ต้องการใช้เท่านั้น
            </div>
            <img
              class="mt-8"
              src="/img/manual/new-user/new-user-step-5-2.jpg"
              alt="new-user-step-5-2"
              width="100%"
            />

            <div class="_fs-20 font-weight-bold mt-8">
              6. กรอกข้อมูลร้านค้า
            </div>
            <div class="_fs-20 mt-4 ml-8">
              &#8226; แบบบุคคล: กรอกเลขที่บัตรประชาชน, ชื่อ-นามสกุล, เบอร์โทร, Email
              และที่อยู่ร้านค้า
            </div>
            <img
              class="mt-8"
              src="/img/manual/new-user/new-user-step-6-1.jpg"
              alt="new-user-step-6-1"
              width="100%"
            />

            <div class="_fs-20 mt-8 ml-8">
              &#8226; แบบนิติบุคคล : เลือกประเภทนิติบุคคล, กรอกเลขประจำตัวผู้เสียภาษี (กดตรวจสอบ),
              ชื่อร้านค้า หรือบริษัท, ระบุสาขา, ชื่อ-นามสกุลผู้ติดต่อ, เบอร์โทร, Email
              และที่อยู่ร้านค้าหรือบริษัท
            </div>
            <img
              class="mt-8"
              src="/img/manual/new-user/new-user-step-6-2.jpg"
              alt="new-user-step-6-2"
              width="100%"
            />
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel
        style="border: 1px solid lightgray"
        class="rounded-xl mt-4"
      >
        <v-expansion-panel-header
          style="height: 90px"
        >
          <div class="_fs-24 font-weight-bold">
            ผู้ใช้ปัจจุบัน (Existing User)
          </div>
          <template v-slot:actions>
            <v-icon
              x-large
              class="mr-4"
            >
              $expand
            </v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-divider />

          <div>
            <div class="_fs-20 mt-4 error--text">
              <span class="font-weight-bold">
                ลูกค้าที่ต้องการใช้ Basic ID แต่ไม่เคยมีในระบบของตน
              </span>
              <span>
                : กดที่ลูกค้าปัจจุบันและกรอก Basic ID โดยดูได้ที่ PC และมือถือ
              </span>
            </div>

            <div class="_fs-20 mt-4">
              สำหรับลูกค้าที่มี Basic ID แล้วสามารถทำตามได้ ดังนี้
            </div>

            <div class="d-flex align-center justify-center mt-8">
              <span
                class="_fs-20 font-weight-bold
                text-center primary lighten-1 white--text py-2 rounded-lg"
                style="width: 500px;"
              >
                ลูกค้าต่อเนื่อง (Existing User): ต่ออายุแพ็กเกจ
              </span>
            </div>

            <div class="_fs-20 font-weight-bold mt-8">
              1. Login
            </div>
            <img
              class="mt-8"
              src="/img/manual/existing-user/package/existing-package-step-1.jpg"
              alt="existing-user-step-1"
              width="100%"
            />

            <div class="_fs-20 font-weight-bold mt-8">
              2. เลือก Basic ID
            </div>
            <img
              class="mt-8"
              src="/img/manual/existing-user/package/existing-package-step-2.jpg"
              alt="existing-user-step-2"
              width="100%"
            />

            <div class="_fs-20 font-weight-bold mt-8">
              3. ไปที่หน้าหลัก และ กดปุ่ม "ต่ออายุแพ็กเกจ"
            </div>
            <img
              class="mt-8"
              src="/img/manual/existing-user/package/existing-package-step-3.jpg"
              alt="existing-user-step-3"
              width="100%"
            />

            <div class="_fs-20 font-weight-bold mt-8">
              4. เลือกแพ็กเกจที่ต้องการ พร้อมระบุวันที่ต้องการเปิดแพ็กเกจให้เรียบร้อย
            </div>
            <img
              class="mt-8"
              src="/img/manual/existing-user/package/existing-package-step-4.jpg"
              alt="existing-user-step-4"
              width="100%"
            />

            <div class="_fs-20 font-weight-bold mt-8">
              5. ตรวจสอบข้อมูลส่วนตัวในการออกใบเสนอราคาให้ถูกต้อง
              หากไม่ใช่หรือต้องการเปลี่ยนใหม่ สามารถกดปุ่มแก้ไขข้อมูลส่วนตัวได้ และกดยืนยัน
            </div>
            <img
              class="mt-8"
              src="/img/manual/existing-user/package/existing-package-step-5.jpg"
              alt="existing-user-step-5"
              width="100%"
            />

            <v-divider class="mt-8" />

            <div class="d-flex align-center justify-center mt-8">
              <span
                class="_fs-20 font-weight-bold
                text-center primary lighten-1 white--text py-2 rounded-lg"
                style="width: 650px;"
              >
                ลูกค้าต่อเนื่อง (Existing User): ต่ออายุพรีเมียม ไอดี (Premium ID)
              </span>
            </div>

            <div class="_fs-20 font-weight-bold mt-8">
              1. Login
            </div>
            <img
              class="mt-8"
              src="/img/manual/existing-user/premium-id/existing-premium-id-step-1.jpg"
              alt="existing-premium-id-step-1"
              width="100%"
            />

            <div class="_fs-20 font-weight-bold mt-8">
              2. เลือก Basic ID
            </div>
            <img
              class="mt-8"
              src="/img/manual/existing-user/premium-id/existing-premium-id-step-2.jpg"
              alt="existing-premium-id-step-2"
              width="100%"
            />

            <div class="_fs-20 font-weight-bold mt-8">
              3. ไปที่หน้าหลักและกดปุ่มต่ออายุ Premium ID
            </div>
            <img
              class="mt-8"
              src="/img/manual/existing-user/premium-id/existing-premium-id-step-3.jpg"
              alt="existing-premium-id-step-3"
              width="100%"
            />

            <div class="_fs-20 font-weight-bold mt-8">
              4. เลือกวันที่ต่ออายุ Premium ID
            </div>
            <img
              class="mt-8"
              src="/img/manual/existing-user/premium-id/existing-premium-id-step-4.jpg"
              alt="existing-premium-id-step-4"
              width="100%"
            />

            <div class="_fs-20 font-weight-bold mt-8">
              5. ตรวจสอบข้อมูลส่วนตัวในการออกใบเสนอราคาให้ถูกต้อง
              หากไม่ใช่หรือต้องการเปลี่ยนใหม่ สามารถกดปุ่มแก้ไขข้อมูลส่วนตัวได้ และกดยืนยัน
            </div>
            <img
              class="mt-8"
              src="/img/manual/existing-user/premium-id/existing-premium-id-step-5.jpg"
              alt="existing-premium-id-step-5"
              width="100%"
            />

            <v-divider class="mt-8" />

            <div class="d-flex align-center justify-center mt-8">
              <span
                class="_fs-20 font-weight-bold
                text-center primary lighten-1 white--text py-2 rounded-lg"
                style="width: 540px;"
              >
                ซื้อข้อความเพิ่มเติม: สามารถซื้อได้ตลอดเวลาหาก Basic ID นั้นมีแพ็กเกจทำงานอยู่
              </span>
            </div>

            <div class="_fs-20 font-weight-bold mt-8">
              1. Login
            </div>
            <img
              class="mt-8"
              src="/img/manual/existing-user/message/existing-message-step-1.jpg"
              alt="existing-message-step-1"
              width="100%"
            />

            <div class="_fs-20 font-weight-bold mt-8">
              2. เลือก Basic ID
            </div>
            <img
              class="mt-8"
              src="/img/manual/existing-user/message/existing-message-step-2.jpg"
              alt="existing-message-step-2"
              width="100%"
            />

            <div class="_fs-20 font-weight-bold mt-8">
              3. ตรวจสอบแพ็กเกจของคุณว่าใช้งานอยู่หรือไม่ ที่หน้าหลัก
            </div>
            <img
              class="mt-8"
              src="/img/manual/existing-user/message/existing-message-step-3.jpg"
              alt="existing-message-step-3"
              width="100%"
            />

            <div class="_fs-20 font-weight-bold mt-8">
              4. เลือกเมนู Message ที่ด้านล่างของหน้าหลักหรือด้านข้าง หัวข้อ "ซื้อบริการ" > Message
            </div>
            <img
              class="mt-8"
              src="/img/manual/existing-user/message/existing-message-step-4.jpg"
              alt="existing-message-step-4"
              width="100%"
            />

            <div class="_fs-20 font-weight-bold mt-8">
              5. พิมพ์จำนวนข้อความที่ต้องการจะซื้อ (อ้างอิงตามราคาในแพ็กเกจนั้นๆ)
            </div>
            <img
              class="mt-8"
              src="/img/manual/existing-user/message/existing-message-step-5.jpg"
              alt="existing-message-step-5"
              width="100%"
            />

            <div class="_fs-20 font-weight-bold mt-8">
              6. ตรวจสอบข้อมูลส่วนตัวในการออกใบเสนอราคาให้ถูกต้อง
              หากไม่ใช่หรือต้องการเปลี่ยนใหม่ สามารถกดปุ่มแก้ไขข้อมูลส่วนตัวได้ และกดยืนยัน
            </div>
            <img
              class="mt-8"
              src="/img/manual/existing-user/message/existing-message-step-6.jpg"
              alt="existing-message-step-6"
              width="100%"
            />
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel
        style="border: 1px solid lightgray"
        class="rounded-xl mt-4"
      >
        <v-expansion-panel-header
          style="height: 90px"
        >
          <div class="_fs-24 font-weight-bold">
            ลูกค้าเว้นระยะ (Re-activate User)
          </div>
          <template v-slot:actions>
            <v-icon
              x-large
              class="mr-4"
            >
              $expand
            </v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-divider />

          <div>
            <div class="d-flex align-center justify-center mt-8">
              <span
                class="_fs-20 font-weight-bold
                text-center primary lighten-1 white--text py-2 rounded-lg"
                style="width: 500px;"
              >
                ลูกค้าเว้นระยะ (Re-activate User): ต่ออายุแพ็กเกจ
              </span>
            </div>

            <div class="_fs-20 font-weight-bold mt-8">
              1. Login
            </div>
            <img
              class="mt-8"
              src="/img/manual/re-activate-user/package/reactivate-package-step-1.jpg"
              alt="reactivate-package-step-1"
              width="100%"
            />

            <div class="_fs-20 font-weight-bold mt-8">
              2. เลือก Basic ID
            </div>
            <img
              class="mt-8"
              src="/img/manual/re-activate-user/package/reactivate-package-step-2.jpg"
              alt="reactivate-package-step-2"
              width="100%"
            />

            <div class="_fs-20 font-weight-bold mt-8">
              3. ไปที่หน้าหลักและกดปุ่มซื้อแพ็กเกจ
            </div>
            <img
              class="mt-8"
              src="/img/manual/re-activate-user/package/reactivate-package-step-3.jpg"
              alt="reactivate-package-step-3"
              width="100%"
            />

            <div class="_fs-20 font-weight-bold mt-8">
              4. เลือกแพ็กเกจที่ต้องการ พร้อมระบุวันที่ต้องการเปิดแพ็กเกจให้เรียบร้อย
            </div>
            <img
              class="mt-8"
              src="/img/manual/re-activate-user/package/reactivate-package-step-4.jpg"
              alt="reactivate-package-step-4"
              width="100%"
            />

            <div class="_fs-20 font-weight-bold mt-8">
              5. ตรวจสอบข้อมูลส่วนตัวในการออกใบเสนอราคาให้ถูกต้อง
              หากไม่ใช่หรือต้องการเปลี่ยนใหม่ สามารถกดปุ่มแก้ไขข้อมูลส่วนตัวได้ และกดยืนยัน
            </div>
            <img
              class="mt-8"
              src="/img/manual/re-activate-user/package/reactivate-package-step-5.jpg"
              alt="reactivate-package-step-5"
              width="100%"
            />

            <v-divider class="mt-8" />

            <div class="d-flex align-center justify-center mt-8">
              <span
                class="_fs-20 font-weight-bold
                text-center primary lighten-1 white--text py-2 rounded-lg"
                style="width: 550px;"
              >
                ลูกค้าเว้นระยะ (Re-activate User): ซื้อพรีเมียม ไอดีใหม่
              </span>
            </div>

            <div class="_fs-20 font-weight-bold mt-8">
              1. Login
            </div>
            <img
              class="mt-8"
              src="/img/manual/re-activate-user/premium-id/reactivate-premium-id-step-1.jpg"
              alt="reactivate-premium-id-step-1"
              width="100%"
            />

            <div class="_fs-20 font-weight-bold mt-8">
              2. เลือก Basic ID
            </div>
            <img
              class="mt-8"
              src="/img/manual/re-activate-user/premium-id/reactivate-premium-id-step-2.jpg"
              alt="reactivate-premium-id-step-2"
              width="100%"
            />

            <div class="_fs-20 font-weight-bold mt-8">
              3. ไปที่หน้าหลักและกดปุ่มซื้อ Premium ID
            </div>
            <img
              class="mt-8"
              src="/img/manual/re-activate-user/premium-id/reactivate-premium-id-step-3.jpg"
              alt="reactivate-premium-id-step-3"
              width="100%"
            />

            <div class="_fs-20 font-weight-bold mt-8">
              4. กรอกชื่อ Premium ID ใหม่ และเลือกวันที่ต้องการใช้งาน
            </div>
            <img
              class="mt-8"
              src="/img/manual/re-activate-user/premium-id/reactivate-premium-id-step-4.jpg"
              alt="reactivate-premium-id-step-4"
              width="100%"
            />

            <div class="_fs-20 font-weight-bold mt-8">
              5. ตรวจสอบข้อมูลส่วนตัวในการออกใบเสนอราคาให้ถูกต้อง
              หากไม่ใช่หรือต้องการเปลี่ยนใหม่ สามารถกดปุ่มแก้ไขข้อมูลส่วนตัวได้ และกดยืนยัน
            </div>
            <img
              class="mt-8"
              src="/img/manual/re-activate-user/premium-id/reactivate-premium-id-step-5.jpg"
              alt="reactivate-premium-id-step-5"
              width="100%"
            />

            <div class="_fs-20 mt-8 error--text text-center">
              **กรณีต้องการใช้ชื่อ Premium ID เดิม
              แต่มีชื่อซ้ำในระบบเนื่องจากมีคนอื่นใช้งานไปแล้วนั้น
              จะไม่สามารถใช้ชื่อเดิมได้
            </div>

            <div class="_fs-20 font-weight-bold mt-8 text-center">
              ซื้อข้อความเพิ่มเติม : หากแพ็กเกจเป็น Free จะไม่สามารถซื้อข้อความเพิ่มเติมได้
            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel
        style="border: 1px solid lightgray"
        class="rounded-xl mt-4"
      >
        <v-expansion-panel-header
          style="height: 90px"
        >
          <div class="_fs-24 font-weight-bold">
            คำถามที่พบบ่อย (FAQs)
          </div>
          <template v-slot:actions>
            <v-icon
              x-large
              class="mr-4"
            >
              $expand
            </v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-divider />

          <div>
            <div class="_fs-20 font-weight-bold mt-8">
              • ซื้อกับเราต่างจากซื้อกับ LINE Thailand โดยตรงอย่างไร?
            </div>
            <img
              class="mt-8"
              src="/img/manual/faqs/with_ssk_benefits.png"
              alt="benefits-comparison"
              width="100%"
            />

            <div class="_fs-20 font-weight-bold mt-8">
              • วิธีดู Basic ID ผ่านแอป LINE Official Account (บนมือถือ)
            </div>
            <div class="_fs-20 mt-4">
              1. เปิดแอป LINE Official Account (โลโก้สีเขียว มีคำว่า "Official Account")
            </div>
            <div class="_fs-20 mt-4">
              2. เลือกบัญชี LINE OA ที่คุณต้องการตรวจสอบ
            </div>
            <div class="_fs-20 mt-4">
              3. ที่หน้าหลักของบัญชี ให้เลือกเมนู "ตั้งค่า" → ไอคอนรูป เฟือง (⚙️)
            </div>
            <div class="_fs-20 mt-4">
              4. เลือกเมนู "บัญชี" และดูที่หัวข้อ "ข้อมูลบัญชี"
            </div>
            <div class="_fs-20 mt-4">
              5. กดที่ "ID" จะเจอ Basic ID → รหัสขึ้นต้นด้วย @ เช่น <span class="primary--text">@abc1234</span>
            </div>

            <div class="_fs-20 font-weight-bold mt-8">
              • วิธีตรวจสอบ Basic ID ผ่านคอม (LINE OA Manager)
            </div>
            <div class="_fs-20 mt-4">
              1. ไปที่เว็บไซต์: <a
                href="https://manager.line.biz"
                target="_blank"
                class="black--text">https://manager.line.biz</a>
            </div>
            <div class="_fs-20 mt-4">
              2. เข้าสู่ระบบด้วยบัญชี LINE ที่ใช้สร้าง OA
            </div>
            <div class="_fs-20 mt-4">
              3. เลือกบัญชี LINE Official Account ที่คุณต้องการตรวจสอบ
            </div>
            <div class="_fs-20 mt-4">
              4. คลิกที่เมนู "การตั้งค่า" (Settings) ด้านขวามือบน
            </div>
            <div class="_fs-20 mt-4">
              5. เลื่อนลง จนเจอหัวข้อ "ข้อมูลบัญชี"
            </div>
            <div class="_fs-20 mt-4">
              6. จะเจอ Basic ID → รหัสขึ้นต้นด้วย @ เช่น <span
                class="primary--text">@abc1234</span>
            </div>

            <div class="_fs-20 font-weight-bold mt-8">
              • ความแตกต่างระหว่าง Premium ID และ Basic ID
            </div>
            <img
              class="mt-8"
              src="/img/manual/faqs/compare_premium_and_basic.png"
              alt="premium-vs-basic-id"
              width="100%"
            />

            <div class="_fs-20 font-weight-bold mt-8">
              • Premium ID คืออะไร
            </div>
            <div class="_fs-20 mt-4">
              พรีเมียมไอดี คือ ID ของ LINE OA ที่ร้านค้า องค์กร แบรนด์สามารถตั้งชื่อได้ตามชื่อได้ตามต้องการ
            </div>
            <div class="_fs-20 mt-4">
              สร้างการจดจำและบอกต่อได้ง่ายและสะดวกขึ้น โดยการสมัครหรือเปิดบัญชี LINE Official Account ใหม่ ผู้สมัครจะได้รับ ID แบบสุ่มเป็นตัวอักษรผสมตัวเลขเรียกว่า Basic ID
            </div>
            <div class="_fs-20 mt-4">
              ยกตัวอย่าง<br />
              เบสิคไอดี : <span class="primary--text">@fr9V01r</span> (ไม่สามารถเลือกหรือเปลี่ยนแปลงได้)<br />
              พรีเมียมไอดี : <span class="primary--text">@sellsuki</span> (สามารถเลือกได้)
            </div>

            <div class="_fs-20 font-weight-bold mt-8">
              • Premium ID ดียังไง
            </div>
            <div class="_fs-20 mt-4">
              สงสัยกันใช่ไหมว่าทำไมเราต้องอัปเกรดเป็นแบบพรีเมียมไอดี นั่นก็เพื่อเพิ่มความสะดวกสบายให้แก่ลูกค้า
              อีกทั้งยังช่วยในเรื่องของการจดจำได้ง่ายเวลาลูกค้าค้นหาในการเพิ่มเพื่อนโดยเราจะเป็นคนตั้งไอดีเอง
              ซึ่งแตกต่างจากเบสิคไอดีที่เป็นการสลับอักษรภาษาอังกฤษกับตัวเลขแบบสุ่ม
              และยังช่วยในเรื่องของ branding และเพิ่มความน่าเชื่อถืออีกด้วย
            </div>
            <div class="_fs-20 mt-4 black--text">
              ที่มา: <a
                href="https://www.sellsuki.co.th/blogs/detail/115/know-how-premium-id-line-oa"
                target="_blank"
                class="black--text">https://www.sellsuki.co.th/blogs/detail/115/know-how-premium-id-line-oa</a>
            </div>

            <div class="_fs-20 font-weight-bold mt-8">
              • ข้อความบรอดแคสต์
            </div>
            <div class="_fs-20 mt-4">
              LINE Official Account สามารถบรอดแคสต์ข้อความได้ 300 ข้อความต่อเดือน ได้ฟรี (โดยนับจากจำนวน Target Reach ที่ได้รับข้อความ)
            </div>

            <div class="_fs-20 font-weight-bold mt-8">
              • วิธีคิดจำนวนข้อความบรอดแคสต์:
            </div>

            <img
              class="mt-8"
              src="/img/manual/faqs/broadcast_message_calculation.png"
              alt="broadcast-message-calculation"
              width="100%"
            />

            <div class="_fs-20 mt-4">
              จำนวนครั้งที่บรอดแคสต์ในการบรอดแคสต์ 1 ครั้ง สามารถตั้งค่าส่งข้อความได้ถึง 3 บอลลูน ‘บอลลูน’ หมายถึง ข้อความ หรือ รูปภาพ สติ๊กเกอร์ คูปองฯ
            </div>
            <div class="_fs-20 mt-4">
              👉 <strong>Target Reach</strong><br />
              คือจำนวนผู้ติดตามใน บัญชี LINE OA ที่คงเหลือจากจำนวนคนที่เพิ่มเพื่อนเข้ามา โดยลบออกจากจำนวน ผู้ติดตามที่บล็อค
            </div>
            <div class="_fs-20 mt-4">
              เช่น มีจำนวน Target Reach 600 คน : 1 บรอดแคสต์ x 600 Target Reach = 600 ข้อความ หากบนบรอดแคสต์เกินแพ็คเกจ จะคิดเป็นราคาต่อข้อความที่เกินมาเป็น Additional Message
            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel
        style="border: 1px solid lightgray"
        class="rounded-xl mt-4"
      >
        <v-expansion-panel-header
          style="height: 90px"
        >
          <div class="_fs-24 font-weight-bold">
            วิธีการแนบใบหักภาษี ณ ที่จ่าย (How to Attach the Withholding Tax)
          </div>
          <template v-slot:actions>
            <v-icon
              x-large
              class="mr-4"
            >
              $expand
            </v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-divider />
          <div>
            <div class="_fs-24 font-weight-bold mt-6">
              วิธีการแนบใบหักภาษี ณ ที่จ่าย
            </div>
            <div class="_fs-20 mt-4">
              คุณสามารถแนบใบหักภาษี ณ ที่จ่ายได้ด้วยตัวเองง่าย ๆ หลังจากชำระเงินสำเร็จ
              ไม่ว่าจะเป็นการชำระผ่านการโอนเงิน, QR Code PromptPay, หรือบัตรเครดิต/เดบิต โดยทำตามขั้นตอนต่อไปนี้:
            </div>
            <div
              class="_fs-20 _fs mt-4"
              style="font-weight: 700;">
              <div>1. ไปที่เมนู “รายการสั่งซื้อ”</div>
              <div>2. เลือกคำสั่งซื้อที่คุณต้องการแนบใบหักภาษี ณ ที่จ่าย</div>
              <div style="color: red;">
                &nbsp;&nbsp;&nbsp;***จะสามารถแนบเอกสารได้ เฉพาะกรณีที่ชำระเงินเรียบร้อยแล้วเท่านั้น
              </div>
              <div>
                3. กดปุ่ม “แนบใบหักภาษี ณ ที่จ่าย
                <img
                  class="my-8"
                  src="/img/manual/how-to-attach-the-withholding-tax/WHTX-step-3.png"
                  alt="reactivate-premium-id-step-3"
                  width="100%"
                />
              </div>
              <div>
                4. แนบไฟล์ใบหักภาษี ณ ที่จ่ายของคุณ
                <img
                  class="my-4"
                  src="/img/manual/how-to-attach-the-withholding-tax/WHTX-step-4.png"
                  alt="reactivate-premium-id-step-4"
                  width="100%"
                />
              </div>
              <div>
                5. เมื่อแนบไฟล์เสร็จแล้ว ให้กดปุ่ม ยืนยัน
                <img
                  class="my-4"
                  src="/img/manual/how-to-attach-the-withholding-tax/WHTX-step-5.png"
                  alt="reactivate-premium-id-step-5"
                  width="100%"
                />
              </div>
              <div>
                6. ระบบจะแสดงป๊อปอัปแจ้งว่าแนบเอกสารสำเร็จแล้ว ให้กดปุ่ม “ตกลง”
                <img
                  class="my-4"
                  src="/img/manual/how-to-attach-the-withholding-tax/WHTX-step-6.png"
                  alt="reactivate-premium-id-step-6"
                  width="100%"
                />
              </div>
              <div>
                7. ระบบจะดำเนินการออกเอกสารใบกำกับภาษีภายใน 1–3 วันทำการ หลังจากแนบใบหักภาษี ณ ที่จ่ายเรียบร้อยแล้ว
                <img
                  class="my-4"
                  src="/img/manual/how-to-attach-the-withholding-tax/WHTX-step-7.png"
                  alt="reactivate-premium-id-step-7"
                  width="100%"
                />
              </div>
              <div>
                8. เมื่อเอกสารใบเสร็จรับเงิน/ใบกำกับภาษีพร้อมให้ดาวน์โหลดแล้ว ท่านสามารถกดที่ปุ่ม 'ดูใบกำกับภาษี' เพื่อเข้าถึงเอกสารดังกล่าวได้
                <img
                  class="my-4"
                  src="/img/manual/how-to-attach-the-withholding-tax/WHTX-step-8.png"
                  alt="reactivate-premium-id-step-8"
                  width="100%"
                />
              </div>
            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel
        v-if="enableTaxAgent"
        style="border: 1px solid lightgray"
        class="rounded-xl mt-4"
      >
        <v-expansion-panel-header
          style="height: 90px"
        >
          <div class="_fs-24 font-weight-bold">
            วิธีการแต่งตั้ง Sellsuki เป็นตัวแทนหักและนำจ่ายภาษี ณ ที่จ่าย
          </div>
          <template v-slot:actions>
            <v-icon
              x-large
              class="mr-4"
            >
              $expand
            </v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-divider />
          <div>
            <div class="_fs-24 font-weight-bold mt-6">
              วิธีการแต่งตั้ง Sellsuki เป็นตัวแทนหักและนำส่งภาษีเงินได้ ณ ที่จ่ายสำหรับลูกค้า นิติบุคคล
            </div>
            <div class="_fs-20 mt-4">
              ท่านสามารถดำเนินการแต่งตั้งให้ Sellsuki เป็นตัวแทนในการหักและนำส่งภาษีเงินได้ ณ ที่จ่าย ผ่านระบบด้วยตนเอง โดยมีขั้นตอนดังนี้:
            </div>
            <div
              class="_fs-20 mt-4">
              <div class="font-weight-bold">
                1. เข้าสู่ระบบ ไปที่เมนู “จัดการบัญชี” และเลือกหัวข้อ “จัดการภาษี”
              </div>
              <div class="font-weight-bold">
                2. คลิกปุ่ม “เริ่มยื่นเอกสาร” เพื่อเริ่มกระบวนการแต่งตั้งตัวแทน
                <img
                  class="my-8"
                  src="/img/manual/tax-agent/tax-agent-1.png"
                  alt="tax-agent-1"
                  width="100%"
                />
              </div>
              <div class="font-weight-bold">
                3. ตรวจสอบข้อมูล และแนบไฟล์ที่เกี่ยวข้องตามที่กำหนดให้ครบถ้วน เมื่อเสร็จสิ้นให้กดปุ่ม “ยืนยัน”
                <img
                  class="my-8"
                  src="/img/manual/tax-agent/tax-agent-2.png"
                  alt="tax-agent-2"
                  width="100%"
                />
              </div>
              <div class="font-weight-bold">
                4. ระบบจะแสดงรายละเอียดข้อมูลและเอกสารที่แนบ เพื่อให้ท่านตรวจสอบความถูกต้องอีกครั้ง จากนั้นให้กดปุ่ม “ยืนยัน” เพื่อส่งข้อมูล
                <img
                  class="my-8"
                  src="/img/manual/tax-agent/tax-agent-3.png"
                  alt="tax-agent-3"
                  width="100%"
                />
              </div>
              <div class="font-weight-bold">
                5. Sellsuki จะดำเนินการนำส่งเอกสารให้หน่วยงานที่เกี่ยวข้องพิจารณา และตรวจสอบเอกสารคำขอ ภายใน 3-5 วันทำการ
              </div>
              <div class="font-weight-bold">
                6. เซลสุกิจะแจ้งผลคำขอของท่านผ่านอีเมล หรือท่านสามารถเข้าดูผลคำขอได้ที่หน้า “จัดการภาษี”
              </div>
              <div class="ml-8">
                <span class="font-weight-bold">• กรณีอนุมัติ:</span> สำหรับคำสั่งซื้อใหม่หลังจากนี้ บริษัท เซลสุกิ จำกัด จะหักภาษี ณ ที่จ่าย 3% และนำส่งกรมสรรพากรผ่านระบบ
              </div>
              <div class="ml-8">
                <span class="font-weight-bold">• กรณีอยู่ระหว่างตรวจสอบ:</span> ระบบจะแสดงสถานะว่ากำลังดำเนินการ
              </div>
              <div class="ml-8">
                <span class="font-weight-bold">• กรณีเอกสารไม่ผ่าน:</span> ท่านสามารถแก้ไขและแนบเอกสารเพื่อยื่นคำขอใหม่ได้ที่หน้า “จัดการภาษี”
              </div>
            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import config from '@/config'

export default {
  name: 'Manual',
  data() {
    return {
      enableTaxAgent: config.ENABLE_TAX_AGENT
    }
  }
}
</script>

<style>
.v-expansion-panel {
  box-shadow: none;
    border: 10px;
}
</style>
